/**
 * @module common/components/form/file_upload_form
 */
import React, { Component, PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import { BASE_64_REGEXP } from 'common/variables';

/**
 * Modal rendering a file upload form used by portfolio or projects
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
export default class FileUploadForm extends Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialFormState();

    this.setFile = this.setFile.bind(this);
    this.selectFormEntry = this.selectFormEntry.bind(this);
    this.changeFormEntryImage = this.changeFormEntryImage.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.closeForm = this.closeForm.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  getInitialFormState() {
    return {
      entry: {
        file: null,
        thumbnail: null,
      },
    };
  }

  getCurrentStep(props) {
    return props.currentStep;
  }

  setFile(fileData, thumbnail) {
    const entry = this.state.entry;
    const file = fileData.replace(BASE_64_REGEXP, '');
    entry.file = file;
    entry.thumbnail = thumbnail;
    this.setState({ entry });
  }

  selectFormEntry() {}

  resetState(newFormStep) {
    this.props.changeStep(newFormStep);
    this.setState({ ...this.getInitialFormState() });
  }

  closeForm() {
    this.resetState();
    this.props.toggleForm();
  }

  submitForm() {}

  getFormStyleNames() {
    return '';
  }
  /**
   * Mobile devices specific steps
   */
  getMobileStep() {
    return null;
  }

  /**
   * Form step component to render. Check /profile/components/portfolio/portfolio_form
   * for sample usage.
   */
  getFormStep() {
    return null;
  }

  render() {
    const dialogClasses = 'file-upload-modal';
    const contentClasses = this.getFormStyleNames();

    return (
      <ModalDialog
        modalHeader={this.getTitle()}
        dialogClasses={dialogClasses}
        contentClasses={contentClasses}
        modalOpen={this.props.formOpen}
        closeAction={this.props.toggleForm}
      >
        {this.getMobileStep()}
        {this.getFormStep()}
      </ModalDialog>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {bool} formOpen - boolean value defining if form is visible
 * @property {func} toggleForm - function called to toggle the form
 * @property {func} changeStep - function to change the form step
 */
FileUploadForm.propTypes = {
  formOpen: PropTypes.bool,
  toggleForm: PropTypes.func,
  changeStep: PropTypes.func,
};



// WEBPACK FOOTER //
// ./common/components/form/file_upload_form.jsx